import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ModalTypes } from "./modals-constant";

type ModalState = {
  modalType: ModalTypes | null;
  modalProps: ModalProps;
};

type ModalProps = {
  [key: string]: any;
};

const initialState: ModalState = { modalType: null, modalProps: {} };
const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<ModalState>) => {
      window.history.replaceState({ modalOpened: true }, "");
      state.modalType = action.payload.modalType;
      state.modalProps = action.payload.modalProps;
    },
    closeModal: (state) => {
      window.history.replaceState({ modalOpened: false }, "");
      state.modalType = null;
      state.modalProps = {};
    },
    updateProps: (state, action: PayloadAction<ModalProps>) => {
      state.modalProps = action.payload.modalProps;
    },
  },
});

export const { openModal, closeModal, updateProps } = modalSlice.actions;
export default modalSlice.reducer;
